module.exports = __webpack_public_path__ + "static/media/lead_closed.6fd56eec.svg";